import { createContext } from "react";

export interface DisplaySettings {
  /** Show flash animation when HP/Resilience values change */
  animateStatChanges: boolean;
}

export interface AppSettings {
  display: DisplaySettings;
}

export const DEFAULT_SETTINGS: AppSettings = {
  display: {
    animateStatChanges: false,
  },
};

export interface SettingsContextType {
  settings: AppSettings;
  updateDisplaySettings: (updates: Partial<DisplaySettings>) => void;
  resetSettings: () => void;
}

export const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);
